import React from "react";
import { FaFire } from "react-icons/fa";
import UserContext from "../UserContext";
import { url } from "../utils/url";
import UserProfile from "../images/avatar-defaul-girls.jpg";
import { Link } from "react-router-dom";
import DiscoverToPosts from "../Components/DiscoverToPosts";

export default function TopHommies({ dark }) {
  const { users } = React.useContext(UserContext);
  return (
    <div className="">
      <h3 className="flex gap-2 text-sm items-center font-bold text-muted my-3">
        <FaFire style={{ color: "orange" }} /> Weekly new hommies
      </h3>
      <div className="ml-0 mt-2">
        <div className="flex flex-column  gap-y-1">
          {users.slice(0, 3).map((user) => {
            return (
              <Link
                to={`/users/${user?.username}`}
                key={user._id}
                className={
                  "justify-start items-center gap-1 flex flex-center no-underline " +
                  (dark ? " text-muted " : " text-dark ")
                }
              >
                <div className="bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center">
                  <img
                    src={
                      `${
                        user?.image ? user?.image : url + user?.profile?.url
                      }` || UserProfile
                    }
                    alt="Commented user"
                    className="w-8 h-8 tophommies-profile object-cover"
                    title={user?.names}
                  />
                </div>
                <div className="ml-1">
                  <p className="m-0 font-bold">{user.names}</p>
                  <span className="m-0 text-xs">{user.username}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
      <h3 className="text-sm font-bold text-muted my-3">Discover</h3>
      <div className="ml-3">
        <DiscoverToPosts />
      </div>
    </div>
  );
}